const ReviewColumnsASI =
  [
    'asiCapabilityId',
    'workflowStatus'
  ];
 const ReviewColumnsPackage =
  [
    'productID',
    'productStatus'
  ];
export {
    ReviewColumnsASI,
    ReviewColumnsPackage
};
